import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {StyleType} from "@catui/types";
import {isNullOrUndefined} from "util";
import {Parameter} from "@catmodels/parameters/types";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {ProjectEvidVid} from "@catmodels/project-evid-functions/types";
import {NotificationsService} from "@catcore/services";
import {getDirtyFormValues} from "@catcore/utils/form-utils";

@Component({
  selector: 'catapp-modify-evid-vid',
  templateUrl: './modify-evid-vid.component.html',
  styleUrls: ['./modify-evid-vid.component.scss']
})
export class ModifyEvidVidComponent {

  styleType = StyleType;

  private _evidVid: ProjectEvidVid;

  form: FormGroup = null;

  @Output() afterUpdate = new EventEmitter<ProjectEvidVid>();

  constructor(private formBuilder: FormBuilder,
              private activeModal: ActiveModal,
              private resourceService: GenericResourceService,
              private notification: NotificationsService) {
    this.form = this.formBuilder.group({
      name: ['', []],
      default_value: ['', []],
    });
  }

  set evidVid(value: ProjectEvidVid) {
    this._evidVid = value;
    this.form.patchValue(this._evidVid);
  }

  get dataIsReady() {
    return !isNullOrUndefined(this._evidVid);
  }

  saveEvidVid($event: MouseEvent) {
    const formValue = getDirtyFormValues(this.form);
    this.resourceService.findServiceForResource(this._evidVid._links.self.href)
      .save(formValue)
      .subscribe((result) => {
        this.notification.success('VID Updated', 'The VID has been updated successfully.');
        this.activeModal.close();
        this.afterUpdate.emit(result);
      });
  }

  cancel($event: MouseEvent) {
    this.activeModal.close();
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-evid-functions/components/modify-evid-vid/modify-evid-vid.component.ts